import React from 'react'
import {Form} from 'antd'

import FormContext from './FormContext'

const FormContextProvider = ({form, children}) => <FormContext.Provider value={form}>{children}</FormContext.Provider>

export default Form.create()(FormContextProvider)
